import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { FiGrid, FiFileText, FiBell, FiFolder } from "react-icons/fi";
import { MdLogout, MdCalendarMonth } from "react-icons/md";
import LogoSideBar from '../../assets/logo-sidebar.svg'
import './MainLayout.scss';
import Header from "../../components/header/Header";
import { Badge, App, Tooltip } from "antd";

const items = [
  { to: "/order-processing/menu", label: "Order Line", icon: FiGrid, key: "order" },
  { to: "/order-processing/saved", label: "Saved Orders", icon: FiFileText, key: "saved" },
  { to: "/order-processing/new", label: "New Bills", icon: FiBell, key: "notification" },
  { to: "/order-processing/calendar", label: "Working Shift", icon: MdCalendarMonth, key: "calendar" },
  { to: "/order-processing/completed", label: "Completed Bills", icon: FiFolder, key: "transactions" },
];

const MainLayout = ({ listBills, ListOfCompletedBills, newBill }) => {
  const { message } = App.useApp();

  const navigate = useNavigate();
  const badgeCounts = {
    order: "",
    saved: listBills.length,
    notification: newBill.length,
    calendar: 0,
    transactions: ListOfCompletedBills.length,
  };

  const handleLogout = () => {
    localStorage.clear();
    message.success("You have logged out successfully");
    setTimeout(() => navigate("/login"), 600);
  };

  return (
    <div className="layout">
      <aside className="sidebar" role="navigation" aria-label="Primary">
        <div className="logo-side-bar">
          <img src={LogoSideBar} alt="logo" />
        </div>
        <ul className="nav">
          {items.map((item) => {
            const Icon = item.icon;
            const badgeValue = badgeCounts[item.key] || 0;
            return (
              <li key={item.to} className="nav-item">
                <Tooltip title={item.label} placement="topRight">
                  <NavLink
                    to={item.to}
                    className={({ isActive }) => "btn" + (isActive ? " is-active" : "")}
                    aria-label={item.label}
                  >
                    {({ isActive }) => (
                      <Badge
                        count={badgeValue}
                        size="medium"
                        offset={[-5, 5]}
                      >
                        <span className="icon-wrap">
                          <Icon style={{ color: isActive ? "white" : "grey", fontSize: "24px" }} />
                        </span>
                      </Badge>
                    )}
                  </NavLink>
                </Tooltip>
              </li>
            );
          })}
        </ul>
        <Tooltip title="Logout" placement="right">
          <p onClick={handleLogout} aria-label="Logout" style={{ cursor: "pointer" }}>
            <MdLogout style={{ color: "grey", fontSize: "24px" }} />
          </p>
        </Tooltip>
      </aside>

      <main className="content">
        <Header />
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
